export default __webpack_public_path__ + "static/SupremeLL-Jumbo-58b6d6f9b9af2b81cafa4c4644acf895.woff";